import "./Design/Dashboard.css"
import { useEffect, useRef, useState } from "react";
import "./Design/Dashboard.css"
import trainingImage from "../Photos/Training/First Step.png"
import "../Dashboard/Courses/MyCourses.css"
import { FirstStepUpdate } from "src/handler/coursehandler";
import AffiliateLink from "./AffiliateLink";
import { Button, Table, TableCell, TableHead } from "@mui/material";
import keyToSuccess from "../Learning/Growniverse Key to Success by R.S.O..pdf";
const Training = () => {
    const [videoPlay, setVideoPlay] = useState("training");
    const playerRef = useRef<HTMLVideoElement | null>(null);
    const changes = async () => {
        if (playerRef.current) {
            await FirstStepUpdate({
                "currentVideoDurationInSeconds": playerRef.current.currentTime,
                "totalVideoDurationInSeconds": playerRef.current.duration
            }, userInformationId)
        }
    }
    const changesOnLoad = async () => {
        if (playerRef.current) {
            var responseData = await FirstStepUpdate({
                "currentVideoDurationInSeconds": playerRef.current.currentTime,
                "totalVideoDurationInSeconds": playerRef.current.duration
            }, userInformationId)
            if (responseData.statusCode === 200) {


                setTimeout(() => {
                    if (playerRef.current) {
                        playerRef.current.currentTime = responseData.data.currentVideoDuration;
                    }
                }, 10);
            }
        }
    }
    const [userInformationId, setUserInformationId] = useState(0);
    const runOnce = useRef(false); // Ref to ensure effect runs only once
    const downloadPdf = () => {
        const link = document.createElement('a');
        link.href = keyToSuccess;
        link.target = '_blank';
        link.click();
    }
    useEffect(() => {
        if (runOnce.current === false) {
            const storedProfile = localStorage.getItem("userProfile");
            const userProfile = JSON.parse(storedProfile ?? "");
            setUserInformationId(userProfile.userInformationId);
            runOnce.current = true;
        }
    }, [runOnce])
    return <>
        <>
            <section className="headerBackgroundReverse" style={{ padding: "30px 5px", background: "" }}>
                <h3 style={{ textAlign: "center", color: "white", background: "black", padding: "10px", borderRadius: "8px" }}>Training</h3>
                <div style={{ background: "black", borderRadius: "10px", padding: "10px" }}>
                    {
                        videoPlay === "training" &&
                        <>
                            <div>
                                <h5 style={{ textAlign: "center", background: "black", color: "white" }}>First Step Meeting</h5>
                                <Button onClick={() => { setVideoPlay("firstStep") }}
                                    className='slide-item px-3'
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        padding: "0",
                                        position: "relative",
                                        display: "block",
                                        justifyContent: "space-between"
                                    }}
                                >
                                    <div>
                                        <img className="trainingImage" src={trainingImage} />
                                    </div>
                                    <div
                                        style={{
                                            backgroundColor: "rgba(255, 255, 255, 0.8)",  // Slightly transparent white background for readability
                                            width: "100%",
                                            textAlign: "left",
                                            color: "black"
                                        }}
                                    >
                                        <h5 style={{ textAlign: "center", background: "", color: "black", fontSize: "20px" }}>
                                            Welcome to Growniverse! 'First Step to Success' guides you through the essential actions to take immediately after enrollment, setting you up for a transformative journey.
                                        </h5>
                                    </div>
                                    <h5 style={{ color: "green" }}>Start First Step</h5>
                                </Button>
                            </div>
                        </>
                    }
                    {
                        videoPlay === "firstStep" &&
                        <>
                            <Button onClick={() => { (setVideoPlay("training")); }} style={{ borderRadius: "20px", color: "white", background: "#343434" }}><i className="fa-solid fa-arrow-left"></i></Button>
                            <div style={{
                                backgroundColor: "black"
                            }}>
                                <div
                                    style={{
                                        background: "black",
                                        padding: "50px 0"
                                    }}
                                >
                                    <div
                                        style={{
                                            position: "relative",
                                            width: "100%",
                                            height: "100vh", // full page height
                                            overflow: "hidden",
                                            background: "black",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <iframe
                                            width="100%"
                                            height="100%"
                                            src="https://www.youtube.com/embed/T6xxgWuJWOw"
                                            title="YouTube video player"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                        ></iframe>
                                    </div>

                                    <div style={{
                                        padding: "20px", display: "flex", justifyContent: "center",
                                        borderBottom: "1px solid #333"
                                    }}>
                                        <h3
                                            style={{
                                                fontSize: "20px",
                                                marginBottom: "10px",
                                                fontWeight: "bold",
                                                color: "white"
                                            }}
                                        >
                                            {"First Step Training"}
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
                <AffiliateLink />
                <section className="headerBackgroundReverse" style={{ padding: "30px", background: "" }}>
                    <h3 style={{ textAlign: "center", color: "white", background: "black", padding: "10px", borderRadius: "8px" }}>Key To Success</h3>
                    <div style={{ background: "white", borderRadius: "10px", padding: "10px" }}>
                        <Table>
                            <TableHead>
                                <TableCell align="center">Key To Success</TableCell>
                                <TableCell align="center"><Button onClick={() => { downloadPdf() }} style={{ gap: "5px" }}>View <i className="fas fa-eye"></i>
                                </Button></TableCell>
                            </TableHead>
                        </Table>
                    </div>
                </section>
            </section>
        </>
    </>
};

export default Training;